/**
 * Takes the arguments passed in and removes any that is not true and joins them again with a space in between
 */
export function cx(...args) {
  return args.filter(Boolean).join(" ");
}
